import MilestoneLogo from '@/assets/integrations/milestone.png'
import MqttLogo from '@/assets/integrations/mqtt.png'
import RestApiLogo from '@/assets/integrations/rest-api.png'
import VpLogo from '@/assets/vp-stripes.png'
import { EventDestination } from '@/types/deployment'

type ConfigValues = {
  name: string
  description: string
  logo: string
}

export const integrationConfig: Record<EventDestination, ConfigValues> = {
  [EventDestination.Visionplatform]: {
    name: 'integrations.platform.title',
    description: 'integrations.platform.description',
    logo: VpLogo
  },
  [EventDestination.CustomApi]: {
    name: 'integrations.restApi.title',
    description: 'integrations.restApi.description',
    logo: RestApiLogo
  },
  [EventDestination.Milestone]: {
    name: 'integrations.milestone.title',
    description: 'integrations.milestone.description',
    logo: MilestoneLogo
  },
  [EventDestination.Mqtt]: {
    name: 'integrations.mqtt.title',
    description: 'integrations.mqtt.description',
    logo: MqttLogo
  }
}
